var render, staticRenderFns
import script from "./table_form.vue?vue&type=script&lang=js"
export * from "./table_form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('146a6683')) {
      api.createRecord('146a6683', component.options)
    } else {
      api.reload('146a6683', component.options)
    }
    
  }
}
component.options.__file = "found/views/config_center/view/list/form/components/table_form.vue"
export default component.exports